import TagManager from "react-gtm-module";

function CompareSchoolArrow({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "compare_schools_arrow",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default CompareSchoolArrow;
